import BaseService from "../../base/base_service";
import {IStandardToastDefinition, IIdleRecomToastDef} from "../../../../common/interfaces/toaster_proxy_service_interface";
import IToasterProxyService from "./toaster_proxy_service_interface";

interface ToasterProxyServiceParams {
    toasterService: () => IToasterProxyService;
}

export default class ToasterProxyService extends BaseService implements IToasterProxyService {
    static CLASS = 'ToasterProxyService';

    private _params: ToasterProxyServiceParams;

    init(params: ToasterProxyServiceParams) {
        this._params = params;
    }

    showStandardToast(options: IStandardToastDefinition) {
        return this._params.toasterService().showStandardToast(options);
    }

    showAckStandardToast(options: IStandardToastDefinition) {
        return this._params.toasterService().showAckStandardToast(options);
    }

    showIdleRecommendationToast(options: IIdleRecomToastDef) {
        return this._params.toasterService().showIdleRecommendationToast(options);
    }
}

